import { Tabs, Typography } from 'antd'
import { useState, useEffect } from 'react'

import { FeatureFlagRuleService } from '@services/FeatureFlagRuleService'
import { FeatureFlagService } from '@services/FeatureFlagService'
import { useNotifications } from '@store/notifications'

import type { FeatureFlag, FeatureFlagRule } from '../types'

import { FeatureFlagRulesTab } from './tabs/FeatureFlagRulesTab/FeatureFlagRulesTab'
import { FeatureFlagsTab } from './tabs/FeatureFlagsTab/FeatureFlagsTab'

export const FeatureFlagDashboardPage = () => {
    const [featureFlags, setFeatureFlags] = useState<FeatureFlag[]>()
    const [featureFlagRules, setFeatureFlagRules] = useState<FeatureFlagRule[]>()
    const { showNotification } = useNotifications()

    const fetchFeatureFlags = async () => {
        try {
            const result = await FeatureFlagService.list()
            setFeatureFlags(result)
        } catch (error) {
            showNotification({ title: 'Error retrieving feature flags', type: 'error' })
        }
    }

    const fetchFeatureFlagRules = async () => {
        try {
            const result = await FeatureFlagRuleService.list()
            setFeatureFlagRules(result)
        } catch (error) {
            showNotification({ title: 'Error retrieving feature flag rules', type: 'error' })
        }
    }
    useEffect(() => {
        fetchFeatureFlags()
        fetchFeatureFlagRules()
    }, [])

    return (
        <>
            <Typography.Title level={1}>Feature Flags</Typography.Title>
            <Tabs style={{ padding: '20px' }}>
                <Tabs.TabPane tab="Feature Flags" key="feature-flags">
                    <FeatureFlagsTab
                        featureFlags={featureFlags}
                        refetchFlags={fetchFeatureFlags}
                        refetchRules={fetchFeatureFlagRules}
                    />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Active Rules" key="active-rules">
                    <FeatureFlagRulesTab
                        featureFlags={featureFlags}
                        featureFlagRules={featureFlagRules}
                        refetchRules={fetchFeatureFlagRules}
                    />
                </Tabs.TabPane>
            </Tabs>
        </>
    )
}
